import React from 'react';

const LOGO_URL = '/brand/harizi-logo-pink-transparent.png';

export function LogoCircle({ size = 56, className = '' }) {
  return (
    <img
      src={LOGO_URL}
      alt="Harizi Gioielli"
      width={size}
      height={size}
      style={{ width: size, height: size, objectFit: 'contain' }}
      className={className}
      data-testid="harizi-logo"
    />
  );
}

export function LogoWordmark({ color = '#171517', goldColor = '#EBBE6A' }) {
  return (
    <div className="flex flex-col items-center" data-testid="harizi-wordmark">
      <div className="font-serif tracking-[0.18em]" style={{ color: goldColor, fontWeight: 500, fontSize: 22 }}>
        HARIZI
      </div>
      <div className="font-sans kerning-luxury" style={{ color, fontSize: 8, marginTop: 1 }}>
        GIOIELLI
      </div>
    </div>
  );
}
